/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetManpowerSettingQuery } from '../../models/get-manpower-setting-query';
import { GetManpowerSettingQueryResult } from '../../models/get-manpower-setting-query-result';

export interface ApiManpowerSettingGetManpowerSettingsPost$Plain$Params {
  
    /**
     * The query parameters for fetching manpower settings.
     */
    body?: GetManpowerSettingQuery
}

export function apiManpowerSettingGetManpowerSettingsPost$Plain(http: HttpClient, rootUrl: string, params?: ApiManpowerSettingGetManpowerSettingsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetManpowerSettingQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiManpowerSettingGetManpowerSettingsPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetManpowerSettingQueryResult>;
    })
  );
}

apiManpowerSettingGetManpowerSettingsPost$Plain.PATH = '/api/ManpowerSetting/GetManpowerSettings';
